export default __webpack_public_path__ + "static/media/isometric-tiles-plum.39236108.webp";